<div class="tw-flex tw-items-center tw-justify-between tw-gap-4">
  <p class="tw-m-0 tw-text-base tw-font-bold tw-leading-5 tw-text-gray-900 dark:tw-text-white">SMS text</p>
  <button type="button" class="tw-inline-flex tw-items-center tw-gap-1 tw-border-0 tw-bg-transparent tw-p-0 tw-text-xs tw-font-medium tw-text-blue-600" (click)="resetMessage()">
    <svg class="tw-h-3.5 tw-w-3.5" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path d="M16.5 10a6.5 6.5 0 1 1-1.8-4.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
      <path d="M16.5 3.5V6.5H13.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    Reset to default
  </button>
</div>
<div
  class="tw-mt-4 tw-overflow-hidden tw-rounded-lg tw-border tw-bg-white dark:tw-bg-gray-800"
  [ngClass]="{
    'tw-border-red-500': showRequiredError,
    'tw-border-gray-200 dark:tw-border-gray-600': !showRequiredError
  }"
>
  <div class="tw-relative tw-min-h-[88px]">
    <div
      #highlight
      class="tw-pointer-events-none tw-whitespace-pre-wrap tw-break-words tw-px-3 tw-py-3 tw-text-sm tw-leading-5 tw-text-gray-800 dark:tw-text-gray-100"
      [attr.dir]="editorRtl() ? 'rtl' : 'ltr'"
      [ngClass]="{ 'tw-text-right': editorRtl(), 'tw-text-left': !editorRtl() }"
      [innerHTML]="highlightedMessage()"
    ></div>
    <textarea
      #messageBox
      class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-resize-none tw-border-0 tw-bg-transparent tw-px-3 tw-py-3 tw-text-sm tw-leading-5 tw-text-transparent tw-caret-gray-800 tw-outline-none dark:tw-caret-gray-100"
      [attr.dir]="editorRtl() ? 'rtl' : 'ltr'"
      [ngClass]="{ 'tw-text-right': editorRtl(), 'tw-text-left': !editorRtl() }"
      (input)="onTemplateInput($event)"
      (blur)="onEditorBlur()"
      (keydown)="onEditorKeydown($event)"
      (mousemove)="onEditorMouseMove($event)"
      (mouseleave)="clearUnknownHoverTip()"
      required
      aria-required="true"
      aria-label="SMS text"
    ></textarea>
    @if (unknownHover(); as hover) {
    <span
      class="tw-pointer-events-none tw-absolute tw-z-20"
      [style.left.px]="hover.left"
      [style.top.px]="hover.top"
      [style.width.px]="hover.width"
      [style.height.px]="hover.height"
      [ngxTippy]="hover.tip"
      [tippyProps]="unknownInsertTippyProps"
    ></span>
    }
  </div>
  <div class="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-border-t tw-border-gray-200 tw-bg-gray-100 tw-px-3 tw-py-2 dark:tw-border-gray-600 dark:tw-bg-gray-700">
    <div class="tw-flex tw-min-w-0 tw-flex-wrap tw-items-center tw-gap-2">
      <span class="tw-text-xs tw-text-gray-500 dark:tw-text-gray-400">Insert</span>
      @for (item of insertChips(); track item.label) {
      <button
        type="button"
        class="tw-inline-flex tw-items-center tw-gap-1 tw-rounded-md tw-border tw-border-gray-200 tw-bg-white tw-px-2 tw-py-1 tw-text-xs tw-text-gray-600 hover:tw-bg-blue-200 active:tw-bg-blue-600 active:tw-text-white dark:tw-border-gray-600 dark:tw-bg-gray-800 dark:tw-text-gray-300 dark:hover:tw-bg-blue-200 dark:active:tw-bg-blue-600 dark:active:tw-text-white"
        (mousedown)="$event.preventDefault()"
        (click)="insertChip(item)"
      >
        <svg class="tw-h-2.5 tw-w-2.5 tw-shrink-0" width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
          <path
            d="M9.44444 4.44444H5.55556V0.555556C5.55556 0.408213 5.49702 0.266905 5.39284 0.162718C5.28865 0.0585316 5.14734 0 5 0C4.85266 0 4.71135 0.0585316 4.60716 0.162718C4.50298 0.266905 4.44444 0.408213 4.44444 0.555556V4.44444H0.555556C0.408213 4.44444 0.266905 4.50298 0.162718 4.60716C0.0585316 4.71135 0 4.85266 0 5C0 5.14734 0.0585316 5.28865 0.162718 5.39284C0.266905 5.49702 0.408213 5.55556 0.555556 5.55556H4.44444V9.44444C4.44444 9.59179 4.50298 9.7331 4.60716 9.83728C4.71135 9.94147 4.85266 10 5 10C5.14734 10 5.28865 9.94147 5.39284 9.83728C5.49702 9.7331 5.55556 9.59179 5.55556 9.44444V5.55556H9.44444C9.59179 5.55556 9.7331 5.49702 9.83728 5.39284C9.94147 5.28865 10 5.14734 10 5C10 4.85266 9.94147 4.71135 9.83728 4.60716C9.7331 4.50298 9.59179 4.44444 9.44444 4.44444Z"
            fill="currentColor"
          />
        </svg>
        {{ item.label }}
      </button>
      }
    </div>
    <span class="tw-shrink-0 tw-text-xs tw-text-gray-500 dark:tw-text-gray-400">{{ characterCount() }} / {{ characterLimit() }} · {{ segmentCount() }} SMS</span>
  </div>
</div>
@if (showRequiredError) {
<p class="tw-mb-0 tw-mt-2 tw-text-xs tw-leading-4 tw-text-red-500">This field is required.</p>
}
<p class="tw-mb-0 tw-mt-2 tw-text-xs tw-leading-4 tw-text-gray-500 dark:tw-text-gray-400">
  SMS count is based on entered guest values, not insert spelling. Length limits vary by provider, up to {{ gsmSegmentLimit }} characters ({{ unicodeSegmentLimit }} if the text
  contains Arabic or emoji). Longer messages are split and billed as multiple SMS. The SMS count shown is an estimate. Cost is
  <span class="tw-font-extrabold">{{ smsMessagePriceUsd }}$</span> per message.
</p>
